module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-13.6d613432.png";